var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3334 22.5334C39.3334 21.8801 39.333 21.5531 39.2058 21.3035C39.094 21.084 38.9162 20.9057 38.6966 20.7938C38.4471 20.6667 38.1197 20.6667 37.4663 20.6667H22.533C21.8796 20.6667 21.5532 20.6667 21.3036 20.7938C21.0841 20.9057 20.9058 21.084 20.7939 21.3035C20.6667 21.5531 20.6667 21.8801 20.6667 22.5334V23.3936C20.6667 23.6789 20.6667 23.8217 20.699 23.956C20.7276 24.075 20.7748 24.1887 20.8388 24.2931C20.9109 24.4108 21.012 24.5119 21.2136 24.7135L27.1202 30.6201C27.3219 30.8218 27.4223 30.9222 27.4944 31.0399C27.5584 31.1443 27.6063 31.2584 27.6348 31.3774C27.6668 31.5103 27.6668 31.6514 27.6667 31.931V37.4795C27.6667 38.4796 27.6667 38.9799 27.8774 39.2811C28.0613 39.5441 28.3451 39.7195 28.6625 39.7664C29.0261 39.8201 29.4736 39.5967 30.3681 39.1494L31.3014 38.6828C31.676 38.4955 31.8628 38.4015 31.9997 38.2618C32.1207 38.1383 32.2132 37.9899 32.2696 37.8264C32.3334 37.6415 32.3334 37.4316 32.3334 37.0128V31.9397C32.3334 31.6543 32.3334 31.5117 32.3657 31.3774C32.3942 31.2584 32.4415 31.1443 32.5055 31.0399C32.5771 30.923 32.6772 30.8229 32.8763 30.6238L32.8803 30.6201L38.7868 24.7135C38.9886 24.5118 39.0889 24.4109 39.1611 24.2931C39.225 24.1887 39.2729 24.075 39.3015 23.956C39.3334 23.8231 39.3334 23.6818 39.3334 23.4023V22.5334Z",
    stroke: "#222423",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.51a837825c61f1a9c6151f6f42a65bd0.svg";
export { ForwardRef as ReactComponent };